import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { WaterfallChart } from '@/common/dashboard/charts/WaterfallChart';
import { StringUtils } from '@/common/utils/StringUtils';
import { Box, Typography, useTheme } from '@mui/material';

export const DemGtnSummaryWaterfallCard = () => {
  const theme = useTheme();

  return (
    <DashboardCard
      title="Gross-to-Net (Total)"
      description="A waterfall chart of the summary's Total column: Gross Sales, then each top-level deduction group, ending at Net Sales."
    >
      {(data) => {
        const gross = data.rows.find((row) => row.id === 'GROSS_SALES')?.total;
        const net = data.rows.find((row) => row.id === 'NET_SALES')?.total;

        if (gross == null) {
          return (
            <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography sx={{ color: 'text.secondary' }}>No data for the selected filters</Typography>
            </Box>
          );
        }

        const topLevelDeductions = data.rows.filter(
          (row) => ['DEDUCTION_GROUP', 'DEDUCTION'].includes(row.rowType) && !row.path.includes('|'),
        );
        const waterfallData = [
          { label: 'Gross Sales', value: gross },
          ...topLevelDeductions.map((row) => ({ label: row.label, value: row.total ?? 0 })),
          { label: 'Net Sales', value: net, kind: 'total' },
        ];

        return (
          <WaterfallChart
            data={waterfallData}
            dataLabels
            upColor={theme.palette.primary.main}
            sumColor={theme.palette.primary.main}
            valueFormatter={(value) => StringUtils.formatCompactNumber(value, { currency: true, accounting: true })}
          />
        );
      }}
    </DashboardCard>
  );
};
